import React from 'react'
import { JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.ExclusiveJob.ContactDetails = React.createClass({
  componentDidMount: function() {
    $('#job-modal .step-title').text('Contact Details')
  },

  render: function() {
    return (
      <div className="form-group">
        <h3 className="mb15 mt10">What phone number can you be reached at?</h3>
        <div className={`${this.props.loading ? '' : 'hidden'}`}>
          <div className="modal-body job-form-body">
            <div className="spinner-icon text-center"/>
          </div>
        </div>
        <div className={`${this.props.loading ? 'hidden' : ''}`}>
          <div className='mt20 form-group phone-number-group active'>
            <label style={{marginRight: '10px'}}>Phone Number</label>
            <div className="input-group p5">
              <span>
                <input
                  name="phone-number"
                  type="textbox"
                  className="form-control js-phone-number"
                  maxLength="30"
                  size="30"
                  onChange={this.props.handlePhoneNumberChange}/>
              </span>
              <span className="input-group-btn">
                <JobWizardMobile.NavigationButtons
                  navButtonLayout='okButton'
                  onStepProgression={this.props.onStepProgression}
                />
              </span>
            </div>
            <div className="row mr20">
              <div className="mt10 pull-right">e.g. 0491 570 110 or 02 7010 1111</div>
            </div>
            <p className="error-message"></p>
          </div>
        </div>
      </div>
    )
  }
})
